const SET_BEAUTY_PREFERENCES_REDESIGNED = 'SET_BEAUTY_PREFERENCES_REDESIGNED';
const SET_BEAUTY_PREFERENCES_WORLD = 'SET_BEAUTY_PREFERENCES_WORLD';

export {
    SET_BEAUTY_PREFERENCES_REDESIGNED, SET_BEAUTY_PREFERENCES_WORLD
};
